var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPurpleCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.15152 5.15152C5.62015 4.68289 6.37995 4.68289 6.84858 5.15152L12 10.303L17.1515 5.15152C17.6202 4.68289 18.3799 4.68289 18.8486 5.15152C19.3172 5.62015 19.3172 6.37995 18.8486 6.84858L13.6971 12L18.8486 17.1515C19.3172 17.6202 19.3172 18.3799 18.8486 18.8486C18.3799 19.3172 17.6202 19.3172 17.1515 18.8486L12 13.6971L6.84858 18.8486C6.37995 19.3172 5.62015 19.3172 5.15152 18.8486C4.68289 18.3799 4.68289 17.6202 5.15152 17.1515L10.303 12L5.15152 6.84858C4.68289 6.37995 4.68289 5.62015 5.15152 5.15152Z",
    fill: "#5A34E1",
    stroke: "#5A34E1",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurpleCloseIcon);
export default __webpack_public_path__ + "static/media/purple_close_icon.030799e73b4e5085ee65bc4eba43e6dc.svg";
export { ForwardRef as ReactComponent };